<template>
  <div class="col-sm-12 nopads">
    <div class="search-form p-2">
      <div class="col-sm-12 span-header pb-2">
        {{ $t('contractor_reports.choose_contractor') }}
      </div>
      <div class="row">
          <div class="col-sm-6 pb-3">
              <!-- Contractor selection -->
              <select
                  id="contractorOrder"
                  v-model="contractor"
                  class="form-select form-select-sm sm-3"
                  :disabled="contractors.length < 1"
              >
                  <option :value="null">
                      {{ $t('orders.select_contractor') }}
                  </option>
                  <option
                      v-for="option in contractors"
                      :key="option.id"
                      :value="option.id"
                  >
                      {{ option.name }}
                  </option>
              </select>
          </div>

          <div class="col-sm-6 pb-3">
              <div class="form-check">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="activeUsersCheckbox"
                      v-model="activeUsers"
                      @change="emitSearch"
                  />
                  <label class="form-check-label ms-2" for="activeUsersCheckbox">
                      {{ $t('contractor_reports.only_active_users') }}
                  </label>
              </div>
          </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'ContractReportFilter',
    mixins: [timeUtils, restApi],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            activeUsers: 1,
            contractor: null,
            contractors: []
        }
    },
    watch: {
        contractor: function () {
            this.emitSearch()
        }
    },
    mounted: function () {
        this.fetchContractors()
    },
    methods: {
        emitSearch: function () {
            this.$emit('search', {contractorId: this.contractor, activeUsers: this.activeUsers})
        },
        fetchContractors: function () {
            this.contractorsLoaded = false
            this.loading = true
            let params = {}
            if (this.company && this.company > 0) {
                params.company = this.company
            }
            this.restFetchParams(this.contractorUrl, params, this.handleContractors)
        },
        handleContractors: function (response) {
            this.loading = false
            if (response && response.data) {
                this.contractors = response.data
            }
        },
    }
}
</script>
